import React from "react";
import { connect } from "react-redux";
import { Field, FieldArray } from "formik";

import Box from "./Box";
import Select from "../../DataEntry/Select";
import ManageContact from "../modal/ManageContact";
import Row from "./Row";

class ContactInfo extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  componentDidUpdate(prevProps: any, _prevState: any) {
    const { contact, contacts, formik } = this.props;
    if (contacts.length !== prevProps.contacts.length) {
      if (contacts.length && !contacts.find((elm: any) => elm.id === contact))
        formik.setFieldValue("contact", contacts[0].id);

      const reconciledData = [];
      contacts.forEach((elm: any, idx: number) => {
        reconciledData[idx] =
          formik.values.contacts.find((c: any) => c.id === elm.id) || elm;
      });

      formik.setFieldValue("contacts", reconciledData);
    }
  }

  handleChangeContact = () => {
    const { formik } = this.props;
    const contacts = formik.errors.contacts || [];

    contacts.forEach((_: any, idx: number) => {
      formik.setFieldValue(`contacts.${idx}.email`, "");
    });
  };

  render() {
    const {
      customerId,
      contacts,
      formik: { values, isSubmitting },
      permissions,
      viewOnly,
    } = this.props;

    return (
      <Box title="Contact(s)">
        <header className="text-center" style={{ paddingTop: "0px" }}>
          <Field
            name="contact"
            className="smart-form-control"
            component={Select}
            style={{ width: "98%" }}
            list={contacts.map((c: any) => [c.id, c.title])}
            disabled={isSubmitting}
            onChange={this.handleChangeContact}
          />
          <br />
        </header>
        <br />

        <FieldArray
          name="contacts"
          render={() =>
            contacts.map((contact: any, idx: number) => (
              <div
                key={contact.id}
                style={{
                  display:
                    values.contact == contact.id || contacts.length === 1
                      ? "block"
                      : "none",
                }}
              >
                <Field name={`contacts.${idx}.id`} type="hidden" />
                <Row
                  label="Name"
                  name={`contacts.${idx}.name`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Tel #1"
                  name={`contacts.${idx}.tel1`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Tel #2"
                  name={`contacts.${idx}.tel2`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Fax"
                  name={`contacts.${idx}.fax`}
                  disabled={viewOnly || isSubmitting}
                />
                <Row
                  label="Email"
                  name={`contacts.${idx}.email`}
                  disabled={viewOnly || isSubmitting}
                />
              </div>
            ))
          }
        />

        <div className="row" style={{ paddingRight: "45px" }}>
          <div
            className="col-md-12 text-right"
            style={{ padding: "10px  20px" }}
          >
            {permissions.customer_manage_contact && !viewOnly ? (
              <ManageContact customerId={customerId} />
            ) : (
              <a className="cursor-not-allowed">Manange</a>
            )}
          </div>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  contacts: state.contacts.data,
  customerId: state.customer.id,
  permissions: state.permissions.data,
});

const mapDispatchToProps = (_dispatch: Function) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfo);
